<template>
  <div class="table-wrapper">
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="100"
      label-position="right"
    >
      <div class="search-right-wrapper">
        <FormItem
          label="预警类型："
          prop="corpType"
          style="width: 286px; text-align: left"
        >
          <Select
            v-model="formInline.warningType"
            placeholder="请选择预警类型"
            clearable
          >
            <Option
              v-for="(item, index) in copeRegisterTypeArr"
              :value="item.value"
              :key="index"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <Button
          style="float: right; margin-left: 10px"
          @click="handleReset"
          >重置</Button
        >
        <Button style="float: right" type="primary" @click="handleQuery"
          >搜索</Button
        >
      </div>
    </Form>
    <Table
      border
      :loading="loading"
      :columns="tableColumns"
      :data="tableData"
      highlight-row
    >
      <template slot-scope="{ row, index }" slot="warningSwitch">
        <span>
          {{ row.warningSwitch == 1 ? "开启" : "关闭" }}
          <i-switch
            :value="row.warningSwitch == 1"
            @on-change="transformation(row)"
          ></i-switch>
        </span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          :disabled="row.warningSwitch == 1"
          class="table-btn"
          type="text"
          size="small"
          @click="handleEdit(row)"
          >编辑</Button
        >
      </template>
    </Table>
    <div class="t-page">
      <Page
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
    <Modal v-model="modalq" title="预警配置" width="25">
      <Form
        ref="formData"
        :model="formData"
        :rules="formRules"
        inline
        :label-width="105"
        label-position="right"
        class="form-list"
      >
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="预警类型：" prop="warningTypeString">
              <Input
                disabled
                v-model="formData.warningTypeString"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="预警项：" prop="warningItem">
              <Input
                disabled
                v-model="formData.warningItem"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="短信通知：" prop="messageSwitch">
              <Radio-group v-model="formData.messageSwitch">
                <Radio :label="1"> 开启 </Radio>
                <Radio :label="0"> 关闭 </Radio>
              </Radio-group>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="紧急程度：" prop="urgencyString">
              <Radio-group v-model="formData.urgencyString">
                <Radio :label="1"> 较低 </Radio>
                <Radio :label="2"> 一般 </Radio>
                <Radio :label="3"> 重要 </Radio>
                <Radio :label="4"> 紧急 </Radio>
              </Radio-group>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="达标标准：" prop="thresholdValue">
              <Input
                v-model="formData.thresholdValue"
                @on-blur="thresholdData"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="预警条件：" prop="greaterOrLess">
              <Select
                v-model="formData.greaterOrLess"
                placeholder="请选择企业类型"
                clearable
              >
                <Option
                  v-for="(item, index) in greaterOrLessTypeArr"
                  :value="item.value"
                  :key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="发送机制：" prop="warningMode">
              <Input
                disabled
                v-model="formData.warningMode"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="modalq = false">取消</Button>
        <Button @click="handleSubmit" :loading="qloading" type="primary"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<style scoped>
</style>
<script>
import tableMixin from "@/components/tableMixin";
export default {
  mixins: [tableMixin],
  data() {
    const validateCode = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请填写达标标准"));
      } else {
        if (this.formData.standard !== -1) {
          const reg = /^([0-9]\d{0,1}|100[%]{1}$)%?$/;
          if (!reg.test(value)) {
            callback(new Error("请输入正确的达标率"));
          } else {
            callback();
          }
        } else if (this.formData.standard == -1) {
          const regPos = /^\d+$/;
          if (!regPos.test(value)) {
            callback(new Error("请输入正确的达标标准"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    return {
      copeRegisterTypeArr: [
        {
          name: "更新率",
          value: 1,
        },
        {
          name: "管理人员到岗率",
          value: 2,
        },
        {
          name: "关键岗位预警",
          value: 3,
        },
        // {
        //   name: "一地接入、全省通用",
        //   value: 4,
        // },
      ],
      greaterOrLessTypeArr: [
        {
          name: "低于阈值预警",
          value: "-1",
        },
        {
          name: "高于阈值预警",
          value: "1",
        },
      ],
      formInline: {
        warningType: "",
      },
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "预警类型",
          key: "warningTypeString",
          minWidth: 80,
          tooltip: true,
        },
        {
          title: "预警项",
          key: "warningItem",
          minWidth: 80,
          tooltip: true,
        },
        {
          title: "达标标准",
          key: "thresholdValue",
        },
        {
          title: "紧急程度",
          key: "urgencyString",
        },
        {
          title: "发送机制",
          key: "warningMode",
          minWidth: 80,
        },
        {
          title: "下次预警时间",
          key: "nextWarningTime",
          minWidth: 80,
          tooltip: true,
          render: (h, params) => {
            return h(
              "span",
              params.row.warningSwitch == 1 ? params.row.nextWarningTime : ""
            );
          },
        },
        {
          title: "短信通知",
          key: "messageSwitch",
          tooltip: true,
          render: (h, params) => {
            return h("span", params.row.messageSwitch == 1 ? "开启" : "关闭");
          },
        },
        {
          title: "任务启停",
          tooltip: true,
          slot: "warningSwitch",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      formData: {
        warningTypeString: "",
        warningItem: "",
        messageSwitch: "",
        urgencyString: "",
        thresholdValue: "",
        greaterOrLess: "",
        warningMode: "",
      },
      formRules: {
        messageSwitch: [
          {
            required: true,
            message: "请选择短信通知",
            type: "number",
            trigger: "change",
          },
        ],
        urgencyString: [
          {
            required: true,
            message: "请选择紧急程度",
            type: "number",
            trigger: "change",
          },
        ],
        thresholdValue: [
          {
            required: true,
            message: "请填写达标标准",
            type: "string",
            trigger: "blur",
          },
          { validator: validateCode, trigger: "blur" },
        ],
        greaterOrLess: [
          { required: true, message: "请选择预警条件", trigger: "change" },
        ],
      },
      tableData: [],
      modalq: false,
      qloading: false,
      areaType: ''
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.areaType = localStorage.getItem('areaType')
    if (this.areaType != 'PROVINCE') {
      this.tableColumns = this.tableColumns.slice(0,-2)
    }
  },
  watch: {},
  methods: {
    /*获取表格数据*/
    getTableData() {
      let param = {
        warningType: this.formInline.warningType,
        size: this.pageSize,
        current: this.page,
          areaCode: this.common.getTenantAreaCode(),
      };
      this.loading = true;
      this.axios({
        method: "post",
        url: "/gd/warningManagement/queryConfig",
        data: param,
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.list;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //重置
    handleReset() {
      this.page = 1;
      this.pageSize = 10
      this.formInline = {
        warningType: "",
      };
      this.getTableData();
    },
    handleEdit(item) {
      this.formData = {};
      this.$refs.formData && this.$refs.formData.resetFields();
      this.formData = {
        warningTypeString: item.warningTypeString,
        warningItem: item.warningItem,
        messageSwitch: item.messageSwitch,
        urgencyString: item.urgency,
        thresholdValue: item.thresholdValue,
        greaterOrLess: item.greaterOrLess.toString(),
        warningMode: item.warningMode,
        standard: item.thresholdValue.indexOf("%"),
        warningItemInteger: item.warningItemInteger,
        urgency: item.urgency
      };
      this.modalq = true;
    },
    transformation(params) {
      let param = {
        warningItem: params.warningItemInteger,
        warningSwitch: params.warningSwitch == 1 ? 0 : 1,
          areaCode: this.common.getTenantAreaCode(),
      };
      this.axios({
        method: "post",
        url: "/gd/warningManagement/warningSwitch",
        data: param,
      }).then((response) => {
        if (response.data.success) {
          this.getTableData();
        }
      });
    },
    thresholdData() {
      if (this.formData.standard !== -1 && this.formData.thresholdValue.indexOf("%") == -1) {
        this.formData.thresholdValue = this.formData.thresholdValue + "%";
      }
    },
    handleSubmit() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          const data = {
            warningItem: this.formData.warningItemInteger,
            thresholdValue: this.formData.thresholdValue.replace('%', ''),
            messageSwitch: this.formData.messageSwitch,
            urgency: this.formData.urgencyString,
            greaterOrLess: Number(this.formData.greaterOrLess),
              areaCode: this.common.getTenantAreaCode(),
          };
          this.qloading = true;
          this.axios({
            method: "post",
            url: "/gd/warningManagement/updateConfig",
            data,
          })
          .then((res) => {
            this.qloading = false;
              if (res.data.success) {
                this.$Message.success("编辑成功!");
                this.modalq = false;
                this.getTableData();
              } else {
                this.$Message.error("编辑失败!");
              }
          })
          .catch(() => {
            this.qloading = false;
          });
        }
      });
    },
  },
};
</script>
